export enum EStatusOcorrencia {
    Aberta = 1,
    EmAtendimento = 2,
    Concluida = 3,
    Cancelada= 4
}
